import { FC } from 'react'

interface LoadingSpinnerProps {
  message?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'ring' | 'dots' | 'pulse'
  className?: string
}

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ 
  message = 'Loading...', 
  size = 'md',
  variant = 'ring',
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  }

  const variantClasses = {
    ring: 'animate-spin rounded-full border-b-2 border-blue-600',
    dots: 'animate-pulse rounded-full bg-blue-600',
    pulse: 'animate-bounce rounded-full bg-blue-600'
  }

  return (
    <div className={`flex flex-col items-center justify-center p-8 ${className}`}>
      <div 
        className={`${variantClasses[variant]} ${sizeClasses[size]}`}
        role="status"
        aria-label="Loading"
      />
      {message && (
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          {message}
        </p>
      )}
    </div>
  )
}

export default LoadingSpinner
